var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDefaultAsset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_36124)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4324_36124)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0 0.0550537)",
    fill: "#D5D7DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40.0551C31.0457 40.0551 40 31.1007 40 20.0551C40 9.00936 31.0457 0.0550537 20 0.0550537C8.9543 0.0550537 0 9.00936 0 20.0551C0 31.1007 8.9543 40.0551 20 40.0551ZM18.4197 22.5153L14.4691 17.7588L8.93823 24.8699H31.0617L23.9506 15.3884L18.4197 22.5153Z",
    fill: "#D5D7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4691 17.7588L18.4197 22.5153L23.9506 15.3884L31.0617 24.8699H8.93823L14.4691 17.7588Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_36124"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0550537,
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4324_36124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.0550537)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultAsset);
export default __webpack_public_path__ + "static/media/imageDefaultAsset.a971602f85c0603115dfbebc6a51ab2a.svg";
export { ForwardRef as ReactComponent };